import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    downloadIcon: {
      verticalAlign: 'text-bottom',
      marginLeft: 8,
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
    downloadLink: {
      alignContent: 'center',
    },
    selectionsHeader: {
      paddingBottom: theme.spacing(2),
    },
    title: {
      paddingBottom: '0 !Important',
      paddingTop: '12px !Important',
    },
    dropdown: {
      '& div': {
        background: `${theme.palette.background.paper} !important`,
        border: 'none !important',
      },
    },
    tableStatements: {
      '& .column-fileName': {
        width: theme.spacing(40),
      },
      '& .fileName': {
        width: theme.spacing(40),
      },
      '& .column-downloadPath': {
        width: theme.spacing(30),
      },
      '& .downloadPath': {
        width: theme.spacing(30),
      },
    },
    tableTaxDocuments: {
      '& .column-year': {
        width: theme.spacing(25),
      },
      '& .date': {
        width: theme.spacing(25),
      },
      '& column-fileName ': {
        width: theme.spacing(30),
      },
      '& .downloadPath': {
        width: theme.spacing(30),
      },
    },
  })
);
